import { API, graphqlOperation } from "aws-amplify";
import { participantValidator } from "./inputFieldValidation.js";
import { updateProject } from "../../graphql/mutations";

const cleanParticipant = (participant) => ({
  email: typeof participant.email === "string" ? participant.email.trim() : participant.email,
  firstName: typeof participant.firstName === "string" ? participant.firstName.trim() : participant.firstName,
  lastName: typeof participant.lastName === "string" ? participant.lastName.trim() : participant.lastName,
  title: typeof participant.title === "string" ? participant.title.trim() : (participant.title || ""),
});

const AddParticipant = async (project, participant) => {

  const participantValidation = participantValidator.validate(participant);
  if(!(participantValidation.error === undefined)){
    throw new Error("Bad request");
  }
  const participantsCopy = (project.participants || []).map(cleanParticipant);
  participantsCopy.push(cleanParticipant(participant));

  const updatedProject = await API.graphql(
    graphqlOperation(updateProject, {
      id: project.id,
      projectName: project.projectName,
      participants: participantsCopy
    })
  );
  return updatedProject;
  
};

export default AddParticipant;
